import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { getBeneficiaryData, getSingleBenDetails, fetchOfficeByCampusId } from "../../pages/actions/actions";
import { ticketDataSuccess } from "../../redux/ticketSlice/ticketSlice";
import { transformLowerCase } from "../../utils/helper";

const useTicketNavigation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchData = useCallback(async (ticketData: any) => {
    if (ticketData?.patient?.id) {
      return getSingleBenDetails(ticketData?.patient?.id, dispatch)

    } else if (ticketData?.subscriber?.id) {
      return getBeneficiaryData(ticketData?.subscriber?.id, dispatch);

    } else if (ticketData?.ticketRaisedBy?.benId) {
      return getSingleBenDetails(ticketData?.ticketRaisedBy?.benId, dispatch);
    } else {
      return [];
    }
  }, [dispatch]);

  const handleRedirect = useCallback(async (record: any) => {
    dispatch(ticketDataSuccess(record));
    await fetchData(record);
    // Load office data if campusId exists
    if (record?.campusId) {
      try {
        await fetchOfficeByCampusId({
          campusId: record.campusId,
          dispatch
        });
      } catch (officeError) {
        console.error("Error fetching office data:", officeError);
      }
    }

    let ticketStatusTransformed = transformLowerCase(record?.ticketStatus);
    let ticketTypeTransformed = transformLowerCase(record?.ticketType);
    let ticketHasPatient = record?.patient;
    if (ticketStatusTransformed === "workinprogress") {
      if ((record?.patientLocation && record.hospitalInfo) || record?.currentMedicalStatusResponse?.isAmbulanceRequired === "No") {
        navigate("/doctor-consult-ambulance");
      } else if (!ticketHasPatient && ticketTypeTransformed === "callbysenior") {
        navigate(`/handleEmergency/${record._id}`);
      } else {
        navigate("/logistics");
      }
    } else if (ticketStatusTransformed === "completed") {
      if (ticketTypeTransformed === "testdemo" || ticketTypeTransformed === "generalenquiry" || ticketTypeTransformed === "customertest" || ticketTypeTransformed === "internaltest") {
        navigate(`/demo-general-enquiry/${record._id}`);
      }else if(!record?.patientLocation || !record.hospitalInfo){
         navigate(`/demo-general-enquiry/${record._id}`);
      }
       else if (record?.patientLocation && record.hospitalInfo) {
        navigate("/doctor-consult-ambulance");
      } else {
        navigate("/logistics");
      }
    } else if (ticketStatusTransformed === "cancelled") {
      navigate(`/cancelled-ticket/${record._id}`);
    }
    else {
      navigate(`/handleEmergency/${record._id}`);
    }
  }, [dispatch, fetchData, navigate]);

  return handleRedirect;
};

export default useTicketNavigation;
